import React from "react";
import escudo from '../images/escudo.png';

function Footer() {

    return (
        <footer className="bg-[#062a1a] border-t border-white/10 mt-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Main content */}
                <div className="py-8 sm:py-12 flex flex-col items-center gap-6">
                    {/* Brand */}
                    <div className="flex flex-col items-center gap-3">
                        <div className="flex items-center gap-3">
                            <img alt="Aguada Crest" className="h-8 sm:h-10 w-auto" src={escudo} />
                            <span className="text-lg sm:text-xl tracking-wider text-green-500 font-semibold">AGUADA <span className="text-red-700">STATS</span></span>
                        </div>
                        <p className="text-slate-400 text-sm sm:text-base font-medium text-center max-w-xs px-6">
                            Estadísticas del club más grande y popular del país
                        </p>
                    </div>

                    {/* Social links */}
                    <div className="flex items-center justify-center gap-5">
                        <a aria-label="Instagram" className="text-slate-500 hover:text-white transition-all transform hover:scale-110" href="https://www.instagram.com/aguadastats/" target="_blank" rel="noreferrer">
                            <svg className="w-6 h-6 sm:w-7 sm:h-7 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.332 3.608 1.308.975.975 1.245 2.242 1.308 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.063 1.366-.333 2.633-1.308 3.608-.975.975-2.242 1.245-3.608 1.308-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.063-2.633-.333-3.608-1.308-.975-.975-1.245-2.242-1.308-3.608-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.062-1.366.332-2.633 1.308-3.608.975-.975 2.242-1.245 3.608-1.308 1.266-.058 1.646-.07 4.85-.07zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948s.014 3.667.072 4.947c.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072s3.667-.014 4.947-.072c4.358-.2 6.78-2.618 6.98-6.98.058-1.281.072-1.689.072-4.948s-.014-3.667-.072-4.947c-.2-4.358-2.618-6.78-6.98-6.98-1.28-.058-1.689-.072-4.948-.072zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.162 6.162 6.162 6.162-2.759 6.162-6.162-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                            </svg>
                        </a>
                        <a aria-label="Twitter X" className="text-slate-500 hover:text-white transition-all transform hover:scale-110" href="https://x.com/aguadastats" target="_blank" rel="noreferrer">
                            <svg className="w-5 h-5 sm:w-6 sm:h-6 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                            </svg>
                        </a>
                    </div>
                </div>

                {/* Bottom bar */}
                <div className="border-t border-white/10 py-5 sm:py-6">
                    <p className="text-slate-500 text-[10px] sm:text-xs font-medium uppercase tracking-[0.15em] sm:tracking-[0.2em] text-center">
                        Desarrollado por <span className="text-slate-300 font-bold">Emiliano Correa Roger</span>
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
